<template>
  <div class="main-connexion">
    <div class=""></div>
    <div class="connexion-content">
      <div class="column is-4 is-offset-4 is-offset-2-mobile is-8-mobile">
        <a
          class="card-content is-flex is-horizontal-center"
          a
          href="https://symbiocenter.fr/"
          target="_blank"
        >
          <img
            src="../assets/img/Logos_Symbiofi_SymbioCenter_PRO_vectoriser.png"
            class=""
          />
        </a>
      </div>

      <div class="">
        <div class="has-text-centered">
          <div class="">
            <h3 class="title has-text-primary">
              {{ $t("Formulaire de souscription au SymbioCenter") }}
            </h3>
            <h2 class="subtitle is-size-5 has-text-primary">
              Offre réservé aux professionnels
            </h2>
          </div>
        </div>
        <!-- <div id="hubspot-form"></div> -->
        <div
          class="column is-offset-3-desktop is-three-fifths-tablet is-offset-one-fifth-tablet is-6-desktop"
        >
          <div class="has-text-centered">
            <div class="column" v-if="!hasSubscription && !isLoaderActive">
              <div class="box">
                <form>
                  <b-field
                    :type="{ 'is-danger': !user.nom && error }"
                    :message="{
                      'Veuillez saisir votre nom de famille':
                        !user.nom && error,
                    }"
                  >
                    <b-input placeholder="Nom de famille" v-model="user.nom">
                    </b-input>
                  </b-field>
                  <b-field
                    :type="{ 'is-danger': !user.prenom && error }"
                    :message="{
                      'Veuillez saisir votre prénom': !user.prenom && error,
                    }"
                  >
                    <b-input
                      placeholder="Prénom"
                      v-model="user.prenom"
                    ></b-input>
                  </b-field>
                  <b-field
                    :type="{ 'is-danger': !user.profession && error }"
                    :message="{
                      'Veuillez saisir votre profession':
                        !user.profession && error,
                    }"
                  >
                    <b-input placeholder="Profession" v-model="user.profession">
                    </b-input>
                  </b-field>
                  <b-field
                    :type="{ 'is-danger': !user.telephone_pro && error }"
                    :message="{
                      'Veuillez saisir votre téléphone professionel':
                        !user.telephone_pro && error,
                    }"
                  >
                    <b-input
                      type="number"
                      placeholder="Téléphone professionel"
                      v-model="user.telephone_pro"
                    >
                    </b-input>
                  </b-field>
                  <b-field
                    :type="{
                      'is-danger':
                        ((!user.mail || errorMessage) && error) ||
                        errorEmailFormat ||
                        errorEmailUse ||
                        errorMajuscule,
                    }"
                    :message="{
                      'Veuillez saisir votre mail professionel':
                        !user.mail && error,
                      'Format de l\'email incorrect': errorEmailFormat,
                      'Email déjà utilisé': errorEmailUse,
                      'L\'email ne doit pas contenir de majuscule':
                        errorMajuscule,
                    }"
                  >
                    <b-input
                      v-model="user.mail"
                      placeholder="Email"
                      type="email"
                    ></b-input>
                  </b-field>
                  <b-field
                    :type="{
                      'is-danger':
                        (isntSamePassword ||
                          !hasMajuscule ||
                          !hasSpecialCharacter ||
                          !hasGoodLength) &&
                        error,
                    }"
                    :message="{
                      'Veuillez saisir un mot de passe':
                        !user.password && error,
                      'Vous n\'avez pas entré le meme mot de passe':
                        isntSamePassword && error,
                      'Le mot de passe doit contenir au moins une majuscule':
                        !hasMajuscule && error,
                      'Le mot de passe doit contenir au moins un caractere special':
                        !hasSpecialCharacter && error,
                      'Le mot de passe doit être superieur ou egal à 8 caractère':
                        !hasGoodLength && error,
                    }"
                  >
                    <b-input
                      type="password"
                      icon-pack="fas"
                      v-model="user.password"
                      placeholder="Mot de passe"
                      password-reveal
                    >
                    </b-input>
                  </b-field>
                  <b-field>
                    <b-input
                      type="password"
                      icon-pack="fas"
                      placeholder="Confirmer le mot de passe"
                      v-model="user.confirmPassword"
                      password-reveal
                    >
                    </b-input>
                  </b-field>
                  <div class="field">
                    <b-checkbox v-model="cgu">
                      {{ $t("cgu2") }} (<a
                        href="https://www.symbiocenter.com/assets/CGU_P_SymbioCenter.pdf"
                        target="_blank"
                        >{{ $t("cgu2_cgu") }}</a
                      >,<a
                        href="https://www.symbiocenter.com/assets/RGPD_SymbioCenter.pdf"
                        target="_blank"
                      >
                        {{ $t("cgu2_rgpd") }}</a
                      >)
                    </b-checkbox>
                  </div>
                  <p
                    v-if="errorCgu"
                    class="has-text-danger has-text-centered is-margin-b-10"
                  >
                    {{ $t("erreurCgu2") }}
                  </p>
                  <a
                    class="button is-blue is-primary is-fullwidth is-large"
                    @click="InscriptionMethod()"
                  >
                    {{ $t("demandeDeSouscription") }}
                  </a>
                </form>
              </div>
            </div>
            <div v-else>
              <div class="column is-6 is-offset-3">
                <div class="box">
                  <LoaderSmb v-if="isLoaderActive">
                    <template #text>
                      <p class="has-text-primary">Inscription en cours</p>
                      <p class="has-text-primary">
                        Veuillez patientez, cela peut prendre quelques temps.
                      </p>
                      <br />
                      <div class="progress-container-inscription">
                        <div
                          class="progress-bar-inscription"
                          :style="{ width: progressBar + '%' }"
                        >
                          <div class="progress-label-inscription">
                            {{ progressBar }}%
                          </div>
                        </div>
                      </div>
                    </template>
                  </LoaderSmb>
                  <p class="title has-text-grey is-size-6 has-text-centered">
                    {{ $t("") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="">

    </div>
    <div class="footer-connexion is-fullwidth">
        <a
          class="button is-blue is-margin-10"
          href="https://www.symbiocenter.com/assets/Mentions_legales.pdf"
          target="_blank"
          ><u>Mentions légales</u></a
        >
        <a
          class="button is-blue is-margin-10"
          href="https://www.symbiofi.com"
          target="_blank"
          ><u>Centre de formation</u></a
        >
      </div>
  </div>
</template>

<script>
import Parse from "parse";
import ParseConfig from "@/api/parse.config.js";
import createUser from "@/services/utilisateurs/user.js";
import codeGenerator from "@/services/general/codeGenerator.js";
import LoaderSmb from "../components/UI/ModalLoaderInscription.vue";

import UserService from "@/services/utilisateurs/NewCreateUser.js";

export default {
  name: "inscriptionCredits",
  components: { LoaderSmb },
  data() {
    return {
      isLoaderActive: false,
      newUser: {
        email: "vueJSuser@example.com",
        firstname: "PrénomVueJS",
        lastname: "Nom",
        // Ajoutez d'autres propriétés du contact si nécessaire.
      },
      progressBar: 0,
      abonnements: {
        1: "gratuit",
        2: "play",
        3: "pulse",
      },
      headingsdisableByDefault: ["actualites", "RetrocessionEtRoyaltiesTitre"],
      defaultLogoFreeSub:
        "assets/img/Logos_Symbiofi_SymbioCenter_couleurs_092021.png",
      user: {
        password: "",
      },
      error: false,
      errorMessage: null,
      errorMajuscule: false,
      hasSubscription: false,
      errorEmailFormat: false,
      errorEmailUse: false,
      errorSamePassword: false,
      errorCgu: false,
      cgu: false,
      isStagiaire: false,
    };
  },
  computed: {
    hasMajuscule() {
      return this.user.password.match(/[A-Z]/g);
    },
    hasSpecialCharacter() {
      return this.user.password.match(/[0-9]/g);
    },
    hasGoodLength() {
      return this.user.password.length >= 8;
    },
    isntSamePassword() {
      return this.user.password !== this.user.confirmPassword;
    },
  },
  created() {
    try {
      const urlParams = new URLSearchParams(window.location.hash.split("?")[1]);
      this.ParamInscription = urlParams.get("type_inscription");
      console.log("ParamInscription", this.ParamInscription);
      if (this.ParamInscription === "stagiaire") {
        this.isStagiaire = true;
      }
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    test() {},
    async addUserInHubspot() {
      ParseConfig();
      var date = new Date();

      // Formater la date en YYYY-MM-DD
      var formattedDate = date.toISOString().substring(0, 10);

      //console.log(formattedDate); // 2023-09-26
      Parse.Cloud.run("addContactToHubSpot", {
        email: this.user.mail.trim(),
        firstname: this.user.prenom,
        lastname: this.user.nom,
        phone: this.user.telephone_pro,
        jobtitle: this.user.profession,
        date_d_inscription: formattedDate,
        offre_pulse: "Gratuit",
      })
        .then((result) => {
          console.log(result);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async sendMail(newUser, utilisateur, objectId) {
      console.log("sendMail", newUser, utilisateur, objectId);
      try {
        await Parse.Cloud.run("informeCompteTherapeuteCree", {
          utilisateur: utilisateur,
          nom: newUser.nom,
          prenom: newUser.prenom,
          telephone: newUser.telephone_pro,
          typeAbonnement: "gratuit",
        });
      } catch (error) {
        console.error("Erreur lors de l'envoi de l'email", error);
      }
      try {
        await Parse.Cloud.run("accountValidationRequest", {
          utilisateur: utilisateur,
          nom: newUser.nom,
          objectId: objectId,
          prenom: newUser.prenom,
        });
      } catch (error) {
        console.error("Erreur lors de l'envoi de l'email", error);
      }
    },
    getAccesWithAbonnement(type_abonnement) {
      if (type_abonnement === this.abonnements[1]) {
        return 1;
      }
      if (type_abonnement === this.abonnements[2]) {
        return 2;
      }
      if (type_abonnement === this.abonnements[3]) {
        return 3;
      }
    },
    isHeadingToActiveByDefault(headingToFind) {
      return this.headingsdisableByDefault.find(
        (heading) => heading == headingToFind
      );
    },
    handleFormSubmit(e) {
      const formInputs = e.target.querySelectorAll("input");
      formInputs.forEach((input) => {
        console.log(`Input name: ${input.name}, Input value: ${input.value}`);
      });
    },
    async InscriptionMethod() {
      ParseConfig();
      try {
        if (this.cgu === false) {
          this.error = true;
          this.errorCgu = true;
          return;
        }
        if (this.user.mail === undefined || this.user.mail.trim() === "") {
          console.log("this.user.mail===undefined");
          this.error = true;
          this.errorMessage = "Veuillez saisir votre mail professionnel.";
          return;
        }
        if (this.user.mail) {
          var userQuery = new Parse.Query(Parse.User);
          userQuery.equalTo("username", this.user.mail.trim());
          const userResponse = await userQuery.find();
          if (userResponse.length) {
            console.log(
              "Un compte existe déjà avec cet email ! Un mail permettant de valider votre compte vous a été envoyé à votre inscription."
            );
            this.error = true;
            this.errorEmailUse = true;
            return;
          }
        }
        console.log(this.user.password, " - ", this.user.confirmPassword);
        //vérifie que c'est les mêmes mots de passe
        if (this.user.password !== this.user.confirmPassword) {
          this.error = true;
          this.errorMessage =
            "Les mots de passe que vous avez saisis ne sont pas identiques";
          console.log(this.errorMessage);
          return;
        }

        if (
          this.user.telephone_pro === undefined ||
          this.user.telephone_pro.trim() === ""
        ) {
          console.log("this.user.telephone_pro===undefined");
          this.error = true;
          this.errorMessage = "Veuillez saisir votre téléphone professionnel.";
          return;
        }

        if (this.user.nom === undefined || this.user.nom.trim() === "") {
          console.log("this.user.nom===undefined");
          this.error = true;
          this.errorMessage = "Veuillez saisir votre nom.";
          return;
        }

        if (this.user.prenom === undefined || this.user.prenom.trim() === "") {
          console.log("this.user.prenom===undefined");
          this.error = true;
          this.errorMessage = "Veuillez saisir votre prénom.";
          return;
        }

        if (
          this.user.profession === undefined ||
          this.user.profession.trim() === ""
        ) {
          console.log("this.user.profession===undefined");
          this.error = true;
          this.errorMessage = "Veuillez saisir votre profession.";
          return;
        }

        this.isLoaderActive = true;
        const user = await UserService.createTherapeute(
          this.user,
          (progress) => {
            this.progressBar = progress;
          },
          this.isStagiaire
        );
        //console.log("user inscription", user);

        if (user) {
          //console.log("User ID:", user.id);
          this.sendMail(this.user, this.user.mail.trim(), user.id);
          try {
            this.addUserInHubspot();
          } catch (error) {
            //console.log(error);
          }
          window.location = "/gestion#/inscription-succeed";
        }
      } catch (error) {
        console.error("Erreur lors de l'inscription", error);
        // Gérer l'erreur ici si nécessaire
      }
    },

    retour() {
      this.hasSubscription = false;
    },
    updateAdresse(e) {
      this.abonnement.adresse = e;
      this.contratAccepte = false;
    },
  },
  mounted() {},
};
</script>

<style>
html,
body,
.main-connexion {
  height: 100%;
  margin: 0;
}

.main-connexion {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.connexion-content {
  flex: 1; /* Permet au contenu principal de prendre tout l'espace restant */
}

.progress-container-inscription {
  width: 100%;
  max-width: 500px;
  background-color: #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.progress-bar-inscription {
  height: 30px;
  background-color: #7957d5;
  position: relative;
  transition: width 0.25s ease-in-out;
}

.progress-label-inscription {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
}
</style>
